import React, { memo } from 'react';
import { calcularPeriodo } from '../Modales/Hooks/useModalFacturaEmitida';

const TIPOS_COMPROBANTE = ['Factura A', 'Factura B', 'Comprobante'];

const SeccionComprobanteFactura = ({
    formData,
    setFormData,
    clientes = [],
    areas = [],
    conceptosFacturas = [],
    handleClienteChange,
    handleAreaChange,
    handleConceptoChange
}) => {
    const handleFechaEmisionChange = (e) => {
        const val = e.target.value;
        const periodo = calcularPeriodo(val);
        setFormData(prev => ({ ...prev, fechaEmision: val, periodo: periodo || prev.periodo }));
    };

    return (
        <fieldset className="border border-slate-200 rounded-xl p-6 relative bg-white shadow-sm transition-all duration-300">
            <legend className="px-3 text-lg font-bold text-slate-700 bg-white absolute -top-3.5 left-4 tracking-tight">
                Comprobante e Identificación
            </legend>
            
            <div className="space-y-4 pt-2">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className="block text-[14px] font-bold text-slate-800 mb-1.5 pl-1">Fecha de Ingreso *</label>
                        <input 
                            type="date" 
                            required 
                            value={formData.fechaIngreso || ''} 
                            onChange={e => setFormData(prev => ({ ...prev, fechaIngreso: e.target.value }))} 
                            className="w-full border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-800 outline-none bg-white h-[46px] focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all" 
                        />
                    </div>
                    <div>
                        <label className="block text-[14px] font-bold text-slate-800 mb-1.5 pl-1">Fecha Emisión *</label>
                        <input 
                            type="date" 
                            required 
                            value={formData.fechaEmision || ''} 
                            onChange={handleFechaEmisionChange} 
                            className="w-full border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-800 outline-none bg-white h-[46px] focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all" 
                        />
                    </div>
                    <div>
                        <label className="block text-[14px] font-bold text-slate-800 mb-1.5 pl-1">Tipo Comprobante *</label>
                        <select 
                            value={formData.tipoComprobante || ''} 
                            onChange={e => setFormData(prev => ({ ...prev, tipoComprobante: e.target.value }))} 
                            className="w-full border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-bold text-slate-800 outline-none bg-white h-[46px] focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all cursor-pointer" 
                            required
                        >
                            <option value="">Seleccionar...</option>
                            {TIPOS_COMPROBANTE.map(t => <option key={t} value={t}>{t}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block text-[14px] font-bold text-slate-800 mb-1.5 pl-1">N° Factura</label>
                        <input 
                            type="text" 
                            value={formData.numeroFactura || ''} 
                            onChange={e => setFormData(prev => ({ ...prev, numeroFactura: e.target.value }))} 
                            className="w-full border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-mono font-bold text-slate-900 outline-none bg-white h-[46px] focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all" 
                            placeholder="0001-00001234" 
                        />
                    </div>
                </div>

                <div>
                    <label className="block text-[14px] font-bold text-slate-800 mb-1.5 pl-1">Cliente (Facturado A) *</label>
                    <select 
                        value={formData.clienteId || ''} 
                        onChange={handleClienteChange} 
                        className="w-full border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-bold text-slate-800 outline-none bg-white h-[46px] focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all cursor-pointer" 
                        required
                    >
                        <option value="">Seleccionar Cliente...</option>
                        {clientes.map(c => <option key={c.id} value={c.id}>{c.razonSocial || c.nombre} {c.cuit ? `(${c.cuit})` : ''}</option>)}
                    </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-[14px] font-bold text-slate-800 mb-1.5 pl-1">Área</label>
                        <select 
                            value={formData.areaId || ''} 
                            onChange={handleAreaChange} 
                            className="w-full border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-800 outline-none bg-white h-[46px] focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all cursor-pointer"
                        >
                            <option value="">Seleccionar Área...</option>
                            {areas.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
                        </select>
                    </div>

                    <div>
                        <label className="block text-[14px] font-bold text-slate-800 mb-1.5 pl-1">Concepto *</label>
                        <select 
                            value={formData.conceptoId || ''} 
                            onChange={handleConceptoChange} 
                            className="w-full border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-bold text-slate-800 outline-none bg-white h-[46px] focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all cursor-pointer" 
                            required
                        >
                            <option value="">Seleccionar Concepto...</option>
                            {conceptosFacturas.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                        </select>
                    </div>
                </div>
            </div>
        </fieldset>
    );
};

export default memo(SeccionComprobanteFactura);